// extracted by mini-css-extract-plugin
export default {"arrowPrev":"ThreeOptions_arrowPrev__y2Qie","arrowNext":"ThreeOptions_arrowNext__UF9xC"};